import type { PlaceRingAction } from "../types/action";
import type { PlayerColor } from "../types/common";
import type { YinshState } from "../types/game-state";

function getOpponent(player: PlayerColor): PlayerColor {
  return player === "WHITE" ? "BLACK" : "WHITE";
}

export function applyPlaceRing(
  state: YinshState,
  action: PlaceRingAction,
): YinshState {
  const newBoard = {
    ...state.board,
    [action.position]: { type: "RING" as const, player: action.player },
  };
  const updatedPlayers: typeof state.players = [
    state.players[0].color === action.player
      ? { ...state.players[0], ringsOnBoard: state.players[0].ringsOnBoard + 1 }
      : state.players[0],
    state.players[1].color === action.player
      ? { ...state.players[1], ringsOnBoard: state.players[1].ringsOnBoard + 1 }
      : state.players[1],
  ];

  const totalRings =
    updatedPlayers[0].ringsOnBoard + updatedPlayers[1].ringsOnBoard;
  const allPlaced = totalRings === 10;

  return {
    ...state,
    board: newBoard,
    players: updatedPlayers,
    phase: allPlaced ? "PLAYING" : "RING_PLACEMENT",
    currentPlayer: allPlaced ? "WHITE" : getOpponent(action.player),
    turn: allPlaced ? 1 : state.turn,
  };
}
